import { Linguist } from "../widgets/Linguist";
import { Say } from "../widgets/Say";
import { PlayUrl } from "./PlayUrl";

export function Approximants() {
  return (<>
    <h2>Approximants</h2>

    ɥ / y - <a href="https://en.wikipedia.org/wiki/Voiced_labial%E2%80%93palatal_approximant">wikipedia</a>
    <ul>
      <li>
        <Say>[ˈɥa | aˈɥa!]</Say>, <Say>[ˈɥe | eˈɥe!]</Say>, <Say>[ˈɥi | iˈɥi!]</Say>, <Say>[ˈɥo | oˈɥo!]</Say>, <Say>[ˈɥu | uˈɥu!]</Say>, <Say>[ˈɥə | əˈɥə!]</Say><br />
        <Say>[['y^a _, a'y^a _!]]</Say>, <Say>[['y^e _, e'y^e _!]]</Say>, <Say>[['y^i _, i'y^i _!]]</Say>, <Say>[['y^o _, o'y^o _!]]</Say>, <Say>[['y^u _, u'y^u _!]]</Say>, <Say>[['y^@ _, @'y^@ _!]]</Say>
      </li>
      <li>
        <Say>[ˈɥɐ | ɐˈɥɐ]</Say>, <Say>[['y^&^ _, &^'y^&^']]</Say>, <Say>[['y^&^ _, &^y'&^']]</Say> -
        <PlayUrl url={'https://upload.wikimedia.org/wikipedia/commons/3/32/LL-Q150_%28fra%29-WikiLucas00-IPA_%C9%A5.wav'} />
      </li>
      <li>
        Swedish:
        <Say>[fʉ̟ɥl]</Say>, <Say>[fʉ̟y̯l]</Say>, <Say>[[fu^y^l]]</Say> -
        <PlayUrl url={'https://upload.wikimedia.org/wikipedia/commons/transcoded/4/4c/Sv-ful.ogg/Sv-ful.ogg.mp3'} />
      </li>
      <li>
        French:
        <Say>[nɥiʁ]</Say>, <Say>[[ny^iQ"]]</Say> -
        <PlayUrl url={'https://upload.wikimedia.org/wikipedia/commons/transcoded/d/dd/Fr-nuire.ogg/Fr-nuire.ogg.mp3'} />
      </li>
      <li>
        French: huit -
        <Say>[ɥit]</Say>, <Say>[[y^it]]</Say> -
        <PlayUrl url={'https://upload.wikimedia.org/wikipedia/commons/0/07/Fr-huit.ogg'} />
      </li>
      <li>
        French: tuer -
        <Say>[tɥe̞]</Say>, <Say>[[tye-]]</Say> -
        <PlayUrl url={'https://upload.wikimedia.org/wikipedia/commons/0/0c/Fr-tuer.ogg'} />
      </li>
      <li>
        <Say>[awaˈɥə]</Say>, <Say>[ɥiːʎɐt]</Say>, <Say>[ɥe̹˥˩]</Say>, <Say>[ɥo̽ʔ˥]</Say>, <Say>[ɥɪl]</Say>, <Say>[ɥæk]</Say>,
        <Say>[ɥe]</Say>, <Say>[ɕɥiʌmɕɥiʌm]</Say>, <Say>[dʉːɥɑː]</Say>, <Say>[dʉ̞ɥ̈ɑˈlɪ̟smə]</Say>, <Say>[ˈnɥɛt͡ʃ]</Say>, <Say>[ɥɪm]</Say>,
        <Say>[d͡ʑɥɛ˩˥]</Say>, <Say>[dɥe˩˥]</Say>
      </li>
      <li>#ɥ:
        <Say>[ɥit]</Say>, <Say>[[y^it]]</Say> - <PlayUrl url={'https://upload.wikimedia.org/wikipedia/commons/0/07/Fr-huit.ogg'} />
        <br /><Say>[ˈɥət]</Say>, <Say>[ˈɥat]</Say>, <Say>[ˈɥet]</Say>, <Say>[ˈɥit]</Say>, <Say>[ˈɥot]</Say>, <Say>[ˈɥut]</Say>,
        <br /><Say>[['y^@t]]</Say>, <Say>[['y^at]]</Say>, <Say>[['y^et]]</Say>, <Say>[['y^it]]</Say>, <Say>[['y^ot]]</Say>, <Say>[['y^ut]]</Say>,
        <br /><Say>[ˈjət]</Say>, <Say>[ˈjat]</Say>, <Say>[ˈjet]</Say>, <Say>[ˈjit]</Say>, <Say>[ˈjot]</Say>, <Say>[ˈjut]</Say>,
      </li>
      <li>VɥV: <Say>[awaˈɥə]</Say>, <Say>[[awa'y^@]]</Say></li>
      <li>VɥC: <Say>[ˈfʉ̟ɥd]</Say>, <Say>[['fu^y^d]]</Say>, <Say>[['fu^y0d]]</Say></li>
      <li>CɥV:
        <Say>[tɥe̞]</Say>, <Say>[[tye-]]</Say> - <PlayUrl url={'https://upload.wikimedia.org/wikipedia/commons/0/0c/Fr-tuer.ogg'} />
        <br /><Say>[ˈnɥɛt͡ʃ]</Say>, <Say>[['ny^E5t+S]]</Say> - <Say>[d͡ʑɥɛ˩˥]</Say>, <Say>[[d+Z;y^E5K9]]</Say>
      </li>
      <li>ɥ#: <Say>[ˈdeɥ]</Say>, <Say>[['dey^]]</Say> - <Say>[ˈeʔɥ]</Say>, <Say>[['e?y^]]</Say></li>
    </ul>

    ɰ / ɯ - <a href="https://en.wikipedia.org/wiki/Voiced_velar_approximant">wikipedia</a>
    <ul>
      <li>
        <Linguist phoneme="ɰ" linguist="JE" />,  <Linguist phoneme="ɰ" linguist="JH" />,  <Linguist phoneme="ɰ" linguist="PL" />,  <Linguist phoneme="ɰ" linguist="JW" />
      </li>
      <li>
        <Say>[ˈɰa | aˈɰa!]</Say>, <Say>[ˈɰe | eˈɰe!]</Say>, <Say>[ˈɰi | iˈɰi!]</Say>, <Say>[ˈɰo | oˈɰo!]</Say>, <Say>[ˈɰu | uˈɰu!]</Say>, <Say>[ˈɰə | əˈɰə!]</Say><br />
        <Say>[['w^a _, a'w^a _!]]</Say>, <Say>[['w^e _, e'w^e _!]]</Say>, <Say>[['w^i _, i'w^i _!]]</Say>, <Say>[['w^o _, o'w^o _!]]</Say>, <Say>[['w^u _, u'w^u _!]]</Say>, <Say>[['w^@ _, @'w^@ _!]]</Say>
      </li>
      <li>
        Catalan:
        <Say>[ˈajɣ̞wə]</Say>, <Say>[['ajw^w@]]</Say> -
        <PlayUrl url={'https://upload.wikimedia.org/wikipedia/commons/transcoded/f/f7/LL-Q7026_%28cat%29-Toniher-aigua.wav/LL-Q7026_%28cat%29-Toniher-aigua.wav.mp3'} />
      </li>
      <li>
        Galician:
        <Say>[ˈɔrɣ̞ɑ̟nʊ]</Say>, <Say>[['ORw^AnU]]</Say> -
        <PlayUrl url={'https://upload.wikimedia.org/wikipedia/commons/transcoded/1/19/LL-Q9307_%28glg%29-Xos%C3%A9-%C3%B3rgano.wav/LL-Q9307_%28glg%29-Xos%C3%A9-%C3%B3rgano.wav.mp3'} />
      </li>
      <li>
        Icelandic:
        <Say>[ˈskäːɣ̞äːˌpɪɣ̞ˑθ]</Say>, <Say>[['ska#:w^a#:,pIw^T]]</Say> -
        <PlayUrl url={'https://upload.wikimedia.org/wikipedia/commons/transcoded/b/b5/Skagabygg%C3%B0_pronunciation.ogg/Skagabygg%C3%B0_pronunciation.ogg.mp3'} />
      </li>
      <li>
        Irish:
        <Say>[n̪ˠɰiː]</Say>, <Say>[[nw^i:]]</Say> -
        <PlayUrl url={'https://upload.wikimedia.org/wikipedia/commons/transcoded/7/75/Ga-naoi.ogg/Ga-naoi.ogg.mp3'} />
      </li>
      <li>
        Spanish:
        <Say>[päˈɣ̞äɾ]</Say>, <Say>[[pa#'w^a#*]]</Say> -
        <PlayUrl url={'https://upload.wikimedia.org/wikipedia/commons/transcoded/0/0d/Es_pagar.ogg/Es_pagar.ogg.mp3'} />
      </li>
      <li>
        Vietnamese:
        <Say>[ɣ̞ap̚˨˩˨]</Say>, <Say>[[w^a3K3p]]</Say> -
        <PlayUrl url={'https://upload.wikimedia.org/wikipedia/commons/transcoded/3/36/LL-Q9199_%28vie%29-Jessica_Nguyen_%28Pamputt%29-g%E1%BA%B7p.wav/LL-Q9199_%28vie%29-Jessica_Nguyen_%28Pamputt%29-g%E1%BA%B7p.wav.mp3'} />
      </li>
      <li>
        <Say>[kajˈʃiɣ̞o̞]</Say>, <Say>[ɰad͡ʒi]</Say>, <Say>[ˈt͡sʰalˀɣ̞]</Say>, <Say>[aɣ̞a]</Say>, <Say>[maɰazˈzi]</Say>, <Say>[ɰoˈtɨo]</Say>
        <Say>[adʒaˈɰa]</Say>, <Say>[wɡ͡ʟɔɣ̞]</Say>, <Say>[úfʌ̟̀ɰɔ̞]</Say>, <Say>[sɑ̃ɰ̃ːi]</Say>, <Say>[ɰisɐ]</Say>, <Say>[haɣ̞haɣ̞]</Say>
        <Say>[ɰ̃ʊ˧n]</Say>, <Say>[i̞ɣ̞i̞]</Say>, <Say>[äɣ̞ɾʊˈn̪oːm]</Say>, <Say>[iːɡɾɪˈje̞ɣ̞ɐ]</Say>, <Say>[ˈŋaɰa]</Say>
      </li>

      <li>#ɰ: <Say>[ɣ̞ap̚˨˩˨]</Say>, <Say>[[w^aK#p]]</Say> - <PlayUrl url={'https://upload.wikimedia.org/wikipedia/commons/transcoded/3/36/LL-Q9199_%28vie%29-Jessica_Nguyen_%28Pamputt%29-g%E1%BA%B7p.wav/LL-Q9199_%28vie%29-Jessica_Nguyen_%28Pamputt%29-g%E1%BA%B7p.wav.mp3'} /></li>
      <li>VɰV: <Say>[päˈɣ̞äɾ]</Say>, <Say>[[pa#'w^a#*]]</Say> - <PlayUrl url={'https://upload.wikimedia.org/wikipedia/commons/transcoded/0/0d/Es_pagar.ogg/Es_pagar.ogg.mp3'} /></li>
      <li>VɰC: <Say>[ˈfʉ̟ɰd]</Say>, <Say>[['fu^w^d]]</Say>, <Say>[['fu^u-0d]]</Say></li>
      <li>
        CɰV: <Say>[ˈɔrɣ̞ɑ̟nʊ]</Say>, <Say>[['O*w^AnU]]</Say> - <PlayUrl url={'https://upload.wikimedia.org/wikipedia/commons/transcoded/1/19/LL-Q9307_%28glg%29-Xos%C3%A9-%C3%B3rgano.wav/LL-Q9307_%28glg%29-Xos%C3%A9-%C3%B3rgano.wav.mp3'} /> -
        <Say>[n̪ɰiː]</Say>, <Say>[[nw^i:]]</Say> -<PlayUrl url={'https://upload.wikimedia.org/wikipedia/commons/transcoded/7/75/Ga-naoi.ogg/Ga-naoi.ogg.mp3'} />
      </li>
      <li>ɰ#: <Say>[ˈdeɰ]</Say>, <Say>[['dew^]]</Say> - <Say>[ˈt͡sʰalˀɣ̞]</Say>, <Say>[['t+s/^al?w^]]</Say></li>
    </ul>
  </>);
}
